export const schoolBoardNamesList = [
  { name: "--Select--", val: "-", key: 0 },
  {
    name: "Central Board of Secondary Edu. 2, Community Centre, Shiksha Kendra, Preet Vihar, Delhi ",
    val: "CBoSE2CCSKPVD",
    key: 1,
  },
  {
    name: "Council for the Indian School Certificate Examinations, Pragati House, Nehru Place, New Delhi ",
    val: "CftISCEPHNPND",
    key: 2,
  },
  {
    name: "U.P. Board of High School & Intermediate Education, Allahabad. ",
    val: "UBoHS&IEA",
    key: 3,
  },
  {
    name: "Rabindra Mukta Vidyalaya, Vikas Bhawan (2nd Floor, East Block), Bidhannagar, Kolkata ",
    val: "RMVVB(FEBBK",
    key: 4,
  },
  {
    name: "Chhatisgarh Board of Secondary Education, Pension Bada, Raipur ",
    val: "CBoSEPBR",
    key: 5,
  },
  {
    name: "Uttarakhand Board of High School & Intermediate Education, Dehradun- ",
    val: "UBoHS&IED",
    key: 6,
  },
  {
    name: "Jharkhand Academic Council, Birsadin, Hawai Nagar, Hatia, Khunti Road, Ranchi ",
    val: "JACBHNHKRR",
    key: 7,
  },
  {
    name: "U.P. Board of Secondary Sanskrit Education Council, Sanskrit Bhawan, 2 Shahmeena Road, Lucknow - 226003 ",
    val: "UBoSSECSB2SRL-2",
    key: 8,
  },
  {
    name: "Rajkiya Institute of Open Schooling, Uttar Pradesh, Lucknow. ",
    val: "RIoOSUPL",
    key: 9,
  },
  { name: "U.P. Board of Madrasa Education, Lucknow ", val: "UBoMEL", key: 10 },
  { name: "Banasthali Vidyapith, Banasthali ", val: "BVB", key: 11 },
  {
    name: "Telangana State Board of Intermediate Education, Hydrabad ",
    val: "TSBoIEH",
    key: 12,
  },
  { name: "Rashtriya Sanskrit Sansthan, New Delhi. ", val: "RSSND", key: 13 },
  { name: "Gurukul Kangri Vishwavidyalaya, Haridwar, ", val: "GKVH", key: 14 },
  {
    name: "Directorate of Army Education, New Delhi. ",
    val: "DoAEND",
    key: 15,
  },
  { name: "Aligarh Muslim University, Aligarh. ", val: "AMUA", key: 16 },
  {
    name: "Jamia Miliya Hamdard University, New Delhi. ",
    val: "JMHUND",
    key: 17,
  },
  { name: "Jamia Millia Islamia, New Delhi ", val: "JMIND", key: 18 },
  { name: "Higher Secondary Education Board, Nepal ", val: "HSEBN", key: 19 },
  { name: "Cambridge International Examinations (CIE) ", val: "CIE(", key: 20 },
  { name: "Other Foreign Board ", val: "OFB", key: 21 },
  {
    name: "Swarajay Senior Secondary School (Accredited by NWAC, USA) ",
    val: "SSSS(bNU",
    key: 22,
  },
  {
    name: "Board of Secondary and Higher Education, U.P.. (Teharki, Meerut) ",
    val: "BoSaHEU(M",
    key: 23,
  },
  {
    name: "Board of Secondary and Higher Education, U.P. ",
    val: "BoSaHEU",
    key: 24,
  },
  {
    name: "Board of Technical Education, Uttar Pradesh ",
    val: "BoTEUP",
    key: 25,
  },
  {
    name: "Bihar School Examination Board, Sinha Library Road, Patna - 800017 ",
    val: "BSEBSLRP-8",
    key: 26,
  },
  { name: "Rajasthan State Open School, Jaipur ", val: "RSOSJ", key: 27 },
  {
    name: "MAHARISHI DAYANANAD UNIVERSITY, ROHTAK, HARYANA ",
    val: "MDURH",
    key: 28,
  },
  {
    name: "Sunrise University, Bagad Rajput, Tech. Ramgarh, Alwar, Rajasthan (Private University) ",
    val: "SUBRTRAR(U",
    key: 29,
  },
  {
    name: "Bihar Board of Open Schooling & Examination, Patna ",
    val: "BBoOS&EP",
    key: 30,
  },
  {
    name: "Uttranchal Shiksha Evm Pariksha Parishad, Pam Nagar, Nanital ",
    val: "USEPPPNN",
    key: 31,
  },
  {
    name: "Bihar Intermediate Education Council, Budh Marg, Patna ",
    val: "BIECBMP",
    key: 32,
  },
  {
    name: "Goa Board of Secondary & Higher Secondary Education, Alto Betim, Berdez, Goa ",
    val: "GBoS&HSEABBG",
    key: 33,
  },
  {
    name: "Gujrat Secondary & Higher Secondary Education, Sector 10B, Near Old, Sachivalaya, Gandhinagar ",
    val: "GS&HSES1NOSG",
    key: 34,
  },
  {
    name: "Board of School Education Haryana, Hansi Road, Bhiwani ",
    val: "BoSEHHRB",
    key: 35,
  },
  {
    name: "Himachal Pradesh Board of School Education, Gayana Lok Parisar, Civil Lines, Dharamsala ",
    val: "HPBoSEGLPCLD",
    key: 36,
  },
  {
    name: "Jammu and Kashmir Board of School Edu., Rehari Colony, Jammu ",
    val: "JaKBoSERCJ",
    key: 37,
  },
  {
    name: "Karnataka Board of Pre-University Education, Technical Education Building, Palace Road, Bangalore ",
    val: "KBoPETEBPRB",
    key: 38,
  },
  {
    name: "Karnataka Secondary Edu. Examination Board, 6th Cross, Malleswaram, Bangalore ",
    val: "KSEEB6CMB",
    key: 39,
  },
  {
    name: "Kerala Board of Public Exam., Pareeksha Bhawan, Poojapura, Thiruvananthapuram ",
    val: "KBoPEPBPT",
    key: 40,
  },
  {
    name: "Kerala Board of Higher Secondary Education, Housing Board Buildings, Santhi Nagar, Thiruvananthapuram ",
    val: "KBoHSEHBBSNT",
    key: 41,
  },
  {
    name: "Madhya Pradesh Board of Higher Secondary Edu., Bhopal ",
    val: "MPBoHSEB",
    key: 42,
  },
  {
    name: "M.P.State Open School Board of Secondary Education, Campus Shivaji Nagar, Bhopal ",
    val: "MOSBoSECSNB",
    key: 43,
  },
  {
    name: "Maharashtra State Board of Secondary & Higher Sec. Education, Campus, Shivajinagar, Pune ",
    val: "MSBoS&HSECSP",
    key: 44,
  },
  {
    name: "Manipur Council of Higher Secondary Education, Babupara, Imphal West-Manipur ",
    val: "MCoHSEBIW",
    key: 45,
  },
  {
    name: "Meghalaya Board of School Edu., West Garo Hills, Tura, Meghalaya ",
    val: "MBoSEWGHTM",
    key: 46,
  },
  {
    name: "Mizoram Board of School Education, Chaltlang, Post Box-7, Aizawl ",
    val: "MBoSECPBA",
    key: 47,
  },
  {
    name: "Nagaland Board of School Education, Post Box-98, Kohima ",
    val: "NBoSEPBK",
    key: 48,
  },
  {
    name: "National Institute of Open Schooling, B-31B, Kailash Colony, New Delhi-110 ",
    val: "NIoOSBKCND",
    key: 49,
  },
  {
    name: "Orissa Council of Higher Secondary Edu. C-2 Pragnyapith, Samantapur,Bhubneshwar ",
    val: "OCoHSECPS",
    key: 50,
  },
  {
    name: "Punjab School Edu. Board, Vidya Bhawan, SAS Nagar, Phase ?8, Mohali ",
    val: "PSEBVBSNP?M",
    key: 51,
  },
  {
    name: "Rajasthan Board of Secondary Education, Ajmer ",
    val: "RBoSEA",
    key: 52,
  },
  {
    name: "Tamil Nadu Board of Higher Secondary Education, DPI Compound, college Road, Chennai ",
    val: "TNBoHSEDCcRC",
    key: 53,
  },
  {
    name: "Tripura Board of Secondary Edu., Nehru Complex, (Gorkha Basti), P.O. Kanjaban, Agartala, Tripura West ",
    val: "TBoSENC(BPKATW",
    key: 54,
  },
  {
    name: "W.B. Council of Higher Secondary Edu., Vidya Sagar Bhawan, 9/2, D.J. Block, Sector-II, Salt Lake, Kolkata ",
    val: "WCoHSEVSB9DBSSLK",
    key: 55,
  },
  {
    name: "W.B. Board of Primary Edu., Acharya Prafulla Chandra Bhawan, DK-7/1, Sector-II, Salt lake, Kolkata ",
    val: "WBoPEAPCBDSSlK",
    key: 56,
  },
  {
    name: "W.B. Board of Madrasah Edu., 19, Haji Md. Mohsin Square, Kolkata ",
    val: "WBoME1HMMSK",
    key: 57,
  },
  {
    name: "Assam Higher Secondary Education Council, Bamunimaidan, Guwahati ",
    val: "AHSECBG",
    key: 58,
  },
  {
    name: "Andhra Pradesh Board of Intermediate Education, Vidya Bhawan, Nampally, Hyderabad ",
    val: "APBoIEVBNH",
    key: 59,
  },
  //   { name: "--Select--", val: "--Select--" },
  //   {
  //     name: "Central Board of Secondary Edu. 2, Community Centre, Shiksha Kendra, Preet Vihar, Delhi ",
  //     val: 1,
  //   },
  //   {
  //     name: "Council for the Indian School Certificate Examinations, Pragati House, Nehru Place, New Delhi ",
  //     val: 2,
  //   },
  //   {
  //     name: "U.P. Board of High School & Intermediate Education, Allahabad. ",
  //     val: 3,
  //   },
  //   {
  //     name: "Rabindra Mukta Vidyalaya, Vikas Bhawan (2nd Floor, East Block), Bidhannagar, Kolkata ",
  //     val: 4,
  //   },
  //   {
  //     name: "Chhatisgarh Board of Secondary Education, Pension Bada, Raipur ",
  //     val: 5,
  //   },
  //   {
  //     name: "Uttarakhand Board of High School & Intermediate Education, Dehradun- ",
  //     val: 6,
  //   },
  //   {
  //     name: "Jharkhand Academic Council, Birsadin, Hawai Nagar, Hatia, Khunti Road, Ranchi ",
  //     val: 7,
  //   },
  //   {
  //     name: "U.P. Board of Secondary Sanskrit Education Council, Sanskrit Bhawan, 2 Shahmeena Road, Lucknow - 226003 ",
  //     val: 8,
  //   },
  //   {
  //     name: "Rajkiya Institute of Open Schooling, Uttar Pradesh, Lucknow. ",
  //     val: 9,
  //   },
  //   { name: "U.P. Board of Madrasa Education, Lucknow ", val: 10 },
  //   { name: "Banasthali Vidyapith, Banasthali ", val: 11 },
  //   {
  //     name: "Telangana State Board of Intermediate Education, Hydrabad ",
  //     val: 12,
  //   },
  //   { name: "Rashtriya Sanskrit Sansthan, New Delhi. ", val: 13 },
  //   { name: "Gurukul Kangri Vishwavidyalaya, Haridwar, ", val: 14 },
  //   { name: "Directorate of Army Education, New Delhi. ", val: 15 },
  //   { name: "Aligarh Muslim University, Aligarh. ", val: 16 },
  //   { name: "Jamia Miliya Hamdard University, New Delhi. ", val: 17 },
  //   { name: "Jamia Millia Islamia, New Delhi ", val: 18 },
  //   { name: "Higher Secondary Education Board, Nepal ", val: 19 },
  //   { name: "Cambridge International Examinations (CIE) ", val: 20 },
  //   { name: "Other Foreign Board ", val: 21 },
  //   {
  //     name: "Swarajay Senior Secondary School (Accredited by NWAC, USA) ",
  //     val: 22,
  //   },
  //   {
  //     name: "Board of Secondary and Higher Education, U.P.. (Teharki, Meerut) ",
  //     val: 23,
  //   },
  //   { name: "Board of Secondary and Higher Education, U.P. ", val: 24 },
  //   { name: "Board of Technical Education, Uttar Pradesh ", val: 25 },
  //   {
  //     name: "Bihar School Examination Board, Sinha Library Road, Patna - 800017 ",
  //     val: 26,
  //   },
  //   { name: "Rajasthan State Open School, Jaipur ", val: 27 },
  //   { name: "MAHARISHI DAYANANAD UNIVERSITY, ROHTAK, HARYANA ", val: 28 },
  //   {
  //     name: "Sunrise University, Bagad Rajput, Tech. Ramgarh, Alwar, Rajasthan (Private University) ",
  //     val: 29,
  //   },
  //   { name: "Bihar Board of Open Schooling & Examination, Patna ", val: 30 },
  //   {
  //     name: "Uttranchal Shiksha Evm Pariksha Parishad, Pam Nagar, Nanital ",
  //     val: 31,
  //   },
  //   {
  //     name: "Bihar Intermediate Education Council, Budh Marg, Patna ",
  //     val: 32,
  //   },
  //   {
  //     name: "Goa Board of Secondary & Higher Secondary Education, Alto Betim, Berdez, Goa ",
  //     val: 33,
  //   },
  //   {
  //     name: "Gujrat Secondary & Higher Secondary Education, Sector 10B, Near Old, Sachivalaya, Gandhinagar ",
  //     val: 34,
  //   },
  //   {
  //     name: "Board of School Education Haryana, Hansi Road, Bhiwani ",
  //     val: 35,
  //   },
  //   {
  //     name: "Himachal Pradesh Board of School Education, Gayana Lok Parisar, Civil Lines, Dharamsala ",
  //     val: 36,
  //   },
  //   {
  //     name: "Jammu and Kashmir Board of School Edu., Rehari Colony, Jammu ",
  //     val: 37,
  //   },
  //   {
  //     name: "Karnataka Board of Pre-University Education, Technical Education Building, Palace Road, Bangalore ",
  //     val: 38,
  //   },
  //   {
  //     name: "Karnataka Secondary Edu. Examination Board, 6th Cross, Malleswaram, Bangalore ",
  //     val: 39,
  //   },
  //   {
  //     name: "Kerala Board of Public Exam., Pareeksha Bhawan, Poojapura, Thiruvananthapuram ",
  //     val: 40,
  //   },
  //   {
  //     name: "Kerala Board of Higher Secondary Education, Housing Board Buildings, Santhi Nagar, Thiruvananthapuram ",
  //     val: 41,
  //   },
  //   { name: "Madhya Pradesh Board of Higher Secondary Edu., Bhopal ", val: 42 },
  //   {
  //     name: "M.P.State Open School Board of Secondary Education, Campus Shivaji Nagar, Bhopal ",
  //     val: 43,
  //   },
  //   {
  //     name: "Maharashtra State Board of Secondary & Higher Sec. Education, Campus, Shivajinagar, Pune ",
  //     val: 44,
  //   },
  //   {
  //     name: "Manipur Council of Higher Secondary Education, Babupara, Imphal West-Manipur ",
  //     val: 45,
  //   },
  //   {
  //     name: "Meghalaya Board of School Edu., West Garo Hills, Tura, Meghalaya ",
  //     val: 46,
  //   },
  //   {
  //     name: "Mizoram Board of School Education, Chaltlang, Post Box-7, Aizawl ",
  //     val: 47,
  //   },
  //   {
  //     name: "Nagaland Board of School Education, Post Box-98, Kohima ",
  //     val: 48,
  //   },
  //   {
  //     name: "National Institute of Open Schooling, B-31B, Kailash Colony, New Delhi-110 ",
  //     val: 49,
  //   },
  //   {
  //     name: "Orissa Council of Higher Secondary Edu. C-2 Pragnyapith, Samantapur,Bhubneshwar ",
  //     val: 50,
  //   },
  //   {
  //     name: "Punjab School Edu. Board, Vidya Bhawan, SAS Nagar, Phase ?8, Mohali ",
  //     val: 51,
  //   },
  //   { name: "Rajasthan Board of Secondary Education, Ajmer ", val: 52 },
  //   {
  //     name: "Tamil Nadu Board of Higher Secondary Education, DPI Compound, college Road, Chennai ",
  //     val: 53,
  //   },
  //   {
  //     name: "Tripura Board of Secondary Edu., Nehru Complex, (Gorkha Basti), P.O. Kanjaban, Agartala, Tripura West ",
  //     val: 54,
  //   },
  //   {
  //     name: "W.B. Council of Higher Secondary Edu., Vidya Sagar Bhawan, 9/2, D.J. Block, Sector-II, Salt Lake, Kolkata ",
  //     val: 55,
  //   },
  //   {
  //     name: "W.B. Board of Primary Edu., Acharya Prafulla Chandra Bhawan, DK-7/1, Sector-II, Salt lake, Kolkata ",
  //     val: 56,
  //   },
  //   {
  //     name: "W.B. Board of Madrasah Edu., 19, Haji Md. Mohsin Square, Kolkata ",
  //     val: 57,
  //   },
  //   {
  //     name: "Assam Higher Secondary Education Council, Bamunimaidan, Guwahati ",
  //     val: 58,
  //   },
  //   {
  //     name: "Andhra Pradesh Board of Intermediate Education, Vidya Bhawan, Nampally, Hyderabad ",
  //     val: 59,
  //   },
];
